const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000/api';

const REVIEWS = {
    POST_REVIEW: `${API_BASE_URL}/reviews/create/`,
    UPDATE_REVIEW: `${API_BASE_URL}/reviews/update/`,
    DELETE_REVIEW: `${API_BASE_URL}/reviews/delete/`,
    USER_REVIEWS: `${API_BASE_URL}/reviews/user-reviews/`,
    USER_REVIEWS_PREVIEW: `${API_BASE_URL}/reviews/user-reviews-preview/`,
    PUBLIC_REVIEWS_PREVIEW: `${API_BASE_URL}/reviews/public-reviews-preview/`,
    REVIEW_VISIBILITY: `${API_BASE_URL}/reviews/visibility`,
    GET_FREELANCER_REVIEWS: `${API_BASE_URL}/reviews/view-reviews`, 
    GET_BUSINESS_REVIEWS: `${API_BASE_URL}/reviews/business-view-reviews`, 
    RATING_SUMMARY: (providerType, providerId) => `${API_BASE_URL}/reviews/summary/${providerType}/${providerId}/`,
};

export default REVIEWS;